import { BBDTag } from '@gravitate-js/excalibrr'
import type { BulkOrderUpdateJobStatus } from '@api/useBulkOrderUpdate/types'

interface JobStatusRendererProps {
  value: BulkOrderUpdateJobStatus
  data: any
}

export function JobStatusRenderer({ value }: JobStatusRendererProps) {
  const getStatusProps = (status: BulkOrderUpdateJobStatus) => {
    switch (status) {
      case 'completed':
        return { success: true }
      case 'failed':
      case 'cancelled':
        return { error: true }
      case 'running':
        return { warning: true }
      case 'queued':
        return { info: true }
      default:
        return {}
    }
  }

  // Add pulse animation for running jobs
  const isRunning = value === 'running'

  return (
    <div className={isRunning ? 'animate-pulse' : ''}>
      <BBDTag textTransform='capitalize' {...getStatusProps(value)}>
        <b>{value}</b>
      </BBDTag>
    </div>
  )
}
